import './product_details_component.scss'

import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['items', 'trigger']

  toggle () {
    if (this.isOpen()) {
      this.itemsTarget.classList.remove('product_details-items--open')
      this.triggerTarget.classList.remove('product_details-trigger--open')
    } else {
      this.itemsTarget.classList.add('product_details-items--open')
      this.triggerTarget.classList.add('product_details-trigger--open')
    }
  }

  isOpen () {
    return this.itemsTarget.classList.contains('product_details-items--open')
  }
}
